var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.2,
    height: 18,
    viewBox: "0 0 16.2 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12508",
    "data-name": "Group 12508",
    transform: "translate(-118 -574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "trash",
    d: "M5.891,14.625V6.375a.369.369,0,0,0-.1-.27A.355.355,0,0,0,5.522,6H4.786a.355.355,0,0,0-.265.105.369.369,0,0,0-.1.27v8.25a.369.369,0,0,0,.1.27A.355.355,0,0,0,4.786,15h.736a.355.355,0,0,0,.265-.105A.369.369,0,0,0,5.891,14.625Zm2.945,0V6.375a.369.369,0,0,0-.1-.27A.355.355,0,0,0,8.468,6H7.731a.355.355,0,0,0-.265.105.369.369,0,0,0-.1.27v8.25a.369.369,0,0,0,.1.27A.355.355,0,0,0,7.731,15h.736a.355.355,0,0,0,.265-.105A.369.369,0,0,0,8.836,14.625Zm2.945,0V6.375a.369.369,0,0,0-.1-.27A.355.355,0,0,0,11.413,6h-.736a.355.355,0,0,0-.265.105.369.369,0,0,0-.1.27v8.25a.369.369,0,0,0,.1.27.355.355,0,0,0,.265.105h.736a.355.355,0,0,0,.265-.105A.369.369,0,0,0,11.781,14.625ZM5.522,3h5.154l-.552-1.371a.324.324,0,0,0-.2-.129H6.282a.324.324,0,0,0-.2.129ZM16.2,3.375v.75a.369.369,0,0,1-.1.269.355.355,0,0,1-.265.105h-1.1V15.609a2.692,2.692,0,0,1-.541,1.682,1.6,1.6,0,0,1-1.3.709H3.313a1.61,1.61,0,0,1-1.3-.685,2.6,2.6,0,0,1-.541-1.658V4.5H.368A.355.355,0,0,1,.1,4.394.369.369,0,0,1,0,4.125v-.75a.369.369,0,0,1,.1-.27A.355.355,0,0,1,.368,3H3.923l.806-1.957A1.619,1.619,0,0,1,5.35.3,1.6,1.6,0,0,1,6.259,0H9.941a1.6,1.6,0,0,1,.909.3,1.616,1.616,0,0,1,.621.739L12.277,3h3.555a.355.355,0,0,1,.265.105.369.369,0,0,1,.1.27Z",
    transform: "translate(118 574)",
    fill: "#74613C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBrown);
export default __webpack_public_path__ + "static/media/deleteBrown.88a7e39a608445cdf3241c9beea5dd2e.svg";
export { ForwardRef as ReactComponent };